module.exports = __webpack_public_path__ + "img/home_poster02.a879862c.jpg";